import React, { useState,useEffect } from "react";
import { Link,useParams } from 'react-router-dom';
import admin from "../../images/banner/admin.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';

const servicesStyle = {
    backgroundImage: `url(${admin})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundColor :'#e6f4ff',
    width :'100%',
    height: '33vh',
};

const Edithvendor = () => {
    let {id} = useParams();
    const [hvendor,setHvendor]=useState({});
    useEffect(() => {
        const fetchData = async () =>{
            try {
                const response = await axios.get(`https://api.transnational.ai/api/edithvendor/${id}`);
                setHvendor(response.data.hvendor)
                console.log(response.data.hvendor)
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    },[])


    const invalidfeedback = {
        display: 'block',
        width: '100%',
        fontSize: '12px',
        color : '#dc3545',
        marginLeft : '0px'
    };

    const [errors, setErrors] = useState({});
	const [success, setSuccess] = useState('');
    const handleChange = (e) => {
        setHvendor({
            ...hvendor,
            [e.target.name]: e.target.value,
        });
    };

    
    const handleSubmit = async (e) => {
        e.preventDefault();
		//console.log(rc);
        try {
            const response = await axios.post(`https://api.transnational.ai/api/updatehvendor/${id}`, hvendor);
            console.log(response.data.hvendor);
            setErrors({});
			setSuccess(response.data.message);
        } catch (error) {
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data.errors);
            } else {
                console.error('Error submitting form:', error);
            }
        }
    };


    return (
        <>
        <section style={{ backgroundColor:'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="media-body" style={{ padding:'10px'}}>
		        <div className="container">
			        <div className="col-md-12" style={{ margin:'0 auto'}}>
				        <div className="well well-small" style={{ textAlign:'left', backgroundColor:'#fff'}} >
					        <ul className="media-list">
						        <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                    <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                        <div  className="col-md-12 breadcrumbs" >
                                        <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Hotlistdashboard">Hotlist Dashboard</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Hvendors"> Hotlist Vendors</a> <i class="bi bi-chevron-double-right"></i> <span> Edit Hotlist Vendor</span>
                                        </div>
                                    </section>
							        <div className="container" style={{ minHeight:'400px'}}>
                                        { success !== '' && <div className="alert alert-success">{success}</div> }
                                        <form id="editprofile" onSubmit={handleSubmit}>
									    <table width={940} border={0} align="center" cellPadding={10} cellSpacing={10}>
										<tr>
											<td width="250"><span >Company Name</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="companyname" maxLength={50} className="ui_text" value={hvendor.companyname} onChange={handleChange} /></td>
                                            <td>{errors.companyname && <span style={invalidfeedback}>{errors.companyname[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Contact Name</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="contactname" maxLength={50} className="ui_text" value={hvendor.contactname} onChange={handleChange} /></td>
                                            <td>{errors.contactname && <span style={invalidfeedback}>{errors.contactname[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Phone</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="phone" maxLength={40} className="ui_text" value={hvendor.phone} onChange={handleChange} /></td>
                                            <td>{errors.phone && <span style={invalidfeedback}>{errors.phone[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Email *</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="email" maxLength={40} className="ui_text" value={hvendor.email}  disabled /></td>
                                            <td></td>
										</tr>
										<tr>
											<td>&nbsp;</td>
											<td></td>
											<td height="50"><input name="changepassword" type="submit" value="Submit" className="btn btn-primary btn-block" style={{ width:'220px'}} /></td>
                                            <td></td>
										</tr>
									    </table>
								        </form> <br/>
							        </div>
                                </li>
                            </ul>
                        </div>
				    </div>
                </div>
            </div>
            
        </section>
        </>
    );
}

export default Edithvendor;